<template>
  <div class="fixed-bottom" style="cursor: pointer">
    <div
      class="mini-player bg-primary rounded col-12 col-md-12 col-lg-4 col-xl-3 float-end mb-3 me-0 me-xl-3 overflow-hidden z-3 position-relative"
    >
      <div class="progress-overlay" @click="$emit('slidebarOpen')">
        <div class="progress-fill" :style="updateProgress"></div>
      </div>

      <div class="progress-line" @click="$emit('slidebarOpen')">
        <div class="progress-line-fill" :style="updateProgress"></div>
      </div>

      <div class="player-content d-flex align-items-center h-100 position-relative">
        <img
          v-if="track?.coverUrl && !imgError"
          :src="track.coverUrl"
          class="mini-cover"
          @click="$emit('slidebarOpen')"
          @error="imgError = true"
        />
        <div
          v-else
          class="mini-cover d-flex align-items-center justify-content-center text-white-50"
          @click="$emit('slidebarOpen')"
        >
          <IconComponent
            lib="filoxenia"
            icon="MusicNote"
            style="width: 24px; height: 24px"
          />
        </div>

        <div class="track-info" @click="$emit('slidebarOpen')">
          <div class="track-title">
            <song-card-text :text="track.name"></song-card-text>
          </div>
        </div>

        <button
          class="btn btn-warning rounded-circle text-white d-flex align-items-center justify-content-center z-2 position-absolute end-0 me-3 play-btn"
          @click="$emit('togglePlayback')"
        >
          <i :class="isPlaying ? 'bi-pause-fill' : 'bi-play-fill'"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";
import type { UseAudioList as Audio } from "@/@types/audio/use_audio";

import SongCardText from "./additionally/song-card-text.vue";
import IconComponent from "../app/_shared/icons/icon-component.vue";

class Props {
  track = prop<Audio>({ required: true, default: null });
  progress = prop<number>({ required: true, default: 0 });
  isPlaying = prop<boolean>({ required: false, default: true });
}

@Options({
  name: "MiniAudioInformer",
  emits: ["play-pause", "open"],
  components: { SongCardText, IconComponent },
  watch: {
    "track.coverUrl": {
      handler() {
        this.imgError = false;
      },
    },
  },
})
class MiniAudioInformer extends Vue.with(Props) {
  imgError = false;

  get updateProgress(): string {
    return `width: ${this.progress}%`;
  }

  handlePlayPauseClick() {
    this.$emit("play-pause");
  }
}
export default MiniAudioInformer;
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";

$player-height: 60px;
:root {
  --progress-color: #3498db;
  --text-color: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.7);
}

.mini-player {
  height: $player-height;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.player-content {
  padding-left: $player-height;
}

.mini-cover {
  position: absolute;
  left: 0;
  width: $player-height;
  height: $player-height;
  object-fit: cover;
}

.track-info {
  flex: 1;
  padding: 0 10px;
  min-width: 0; /* Для правильной работы ellipsis */
}

.track-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.track-artist {
  font-size: 11px;
  color: var(--text-secondary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.play-btn {
  width: 32px;
  height: 32px;
}

.play-btn i {
  font-size: 14px;
  margin-left: 1px; /* Центрирование иконки play */
}

/* Прогресс бар на всю ширину */
.progress-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.progress-fill {
  height: 100%;
  background: rgba(52, 152, 219, 0.15);
  width: 0%;
  transition: width 0.1s linear;
  border-radius: 10px;
}

/* Вариант с тонкой линией прогресса */
.progress-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.progress-line-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--progress-color), #2ecc71);
  width: 0%;
  transition: width 0.1s linear;
}

/* Альтернативный стиль с градиентом */
.mini-player.gradient {
  background: linear-gradient(90deg, #1a1a2e, #16213e);
}

.mini-player.compact {
  width: 250px;
}

.mini-player.light .progress-fill {
  background: rgba(0, 123, 255, 0.1);
}

.mini-player.light .progress-line {
  background: rgba(0, 0, 0, 0.1);
}
</style>
